import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "../index.css";
import { useEffect, useState } from "react";

export const ListElement = ({
  listRef,
  children,
  scrollSnapping,
  showCarousel
}) => {
  const [shouldHaveGradient, setShouldHaveGradient] = useState(false);

  useEffect(() => {
    if (listRef.current) {
      const liElements = listRef.current.querySelectorAll("li");
      setShouldHaveGradient(liElements.length >= 5);
    }
  }, [children]);

  return (
    <ul
      ref={listRef}
      className={classnames(styles.list, {
        [styles.scrollSnapping]: scrollSnapping,
        [styles.listGradient]: shouldHaveGradient
      })}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={showCarousel ? 0 : undefined}
    >
      {children}
    </ul>
  );
};

ListElement.propTypes = {
  listRef: PropTypes.object,
  children: PropTypes.node,
  scrollSnapping: PropTypes.bool,
  showCarousel: PropTypes.bool
};
